const CONFIG_CATEGORIES = {
  PACIENTE: `paciente`,
  COLORS: `colors`,
}

const CONFIG_KEYS = {
  PACIENTE: {
    ADMIT_SOCIAL_NAME: `admitSocialName`,
  },
  COLORS: {
    TOTEM: `totem`,
    TV: `tv`,
  },
}

export { CONFIG_CATEGORIES, CONFIG_KEYS }
